export enum SortOrder {
  Asc = 1,
  Desc = -1,
}

export const sortObjectArray = (
  arr: any[],
  key: string,
  order: SortOrder = SortOrder.Asc
): any[] => {
  arr.sort((a, b) => {
    if (!a[key]) {
      return 1;
    }
    if (!b[key]) {
      return -1;
    }
    if (a[key] < b[key]) {
      return -1 * order;
    }
    if (a[key] > b[key]) {
      return 1 * order;
    }
    return 0;
  });

  return arr;
};

export const splitArray = (array: any[], size: number): any[][] => {
  if (array.length <= size) {
    return [array];
  }
  return [array.slice(0, size), ...splitArray(array.slice(size), size)];
};

export const deleteItemFromArray = (array: any[], index: number) => {
  const newArray = [...array];
  const deleted = newArray.splice(index, 1);
  return { array: newArray, deleted };
};

export function getNextListIndex<T>(list: T[], highlighted: T, isUp: boolean) {
  const index = list.indexOf(highlighted);

  if (isUp) {
    return index <= 0 ? 0 : index - 1;
  }
  return index === list.length - 1 ? list.length - 1 : index + 1;
}
